import React, { useState, useEffect } from "react";
import LinearProgress from "@mui/material/LinearProgress";

import styles from "./Loading.module.scss";

export function Loading(props: {
  title: string,
  body: string
}) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 1200);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={styles.Loading}>
      <div className={styles.Title}>{props.title}</div>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          backgroundColor: "#bfc8d3",
          borderRadius: "4px",
          "& .MuiLinearProgress-barColorPrimary": {
            background: "linear-gradient(90deg, #266FE6, #7CA9F0)",
            borderRadius: "4px",
          },
        }}
      />
      <div className={styles.Body}>{props.body}</div>
    </div>
  );
}

